import React, { Component } from "react";
import BigCalendar from "react-big-calendar";

import moment from "moment";
import "moment/locale/es";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-widgets/dist/css/react-widgets.css";
import dates from "react-big-calendar/lib/utils/dates";
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Modal,
  Button,
  Checkbox
} from "react-bootstrap";
import Globalize from "globalize";
import globalizeLocalizer from "react-widgets-globalize";
import { DateTimePicker } from "react-widgets";

import Autosuggest from "react-autosuggest";

const axios = require("axios");

const localizer = BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
globalizeLocalizer();

class TurnosCalendar extends Component {
  state = {};

  constructor(props) {
    super(props);
    this.state = {
      events: [{}],
      paciente: "",
      email: "",
      celular: "",
      fechaNacimiento: "",
      fechastartevent: "",
      fechaendevent: "",
      modaltitle: "",
      fetching: false,
      value: "",
      suggestions: [],
      users: []
    };
  }

  componentDidMount() {
    var tempDate = new Date();
    var date =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate();
    this.setState({ currentDate: date, deshabilitar: false });
    this.getUsers();
  }

  componentDidUpdate(prevProps, prevState) {
    console.log(
      "UPDATE" + this.state.events.length + " " + this.props.professionalId
    );
    if (prevProps.professionalId !== this.props.professionalId) {
      this.onChangeProfessional(
        this.props.professionalId,
        this.props.professionalName
      );
      return;
    }

    if (this.props.professionalId !== "" && this.state.events.length === 1) {
      this.onChangeProfessional(
        this.props.professionalId,
        this.props.professionalName
      );
      return;
    }
  }

  getUsers = () => {
    this.callUsuariosAPI();
  };

  callUsuariosAPI = async () => {
    const response = await fetch("http://190.105.227.203/turnos/usuarios");
    const res = await response.json();
    if (response.status !== 200) {
      throw Error(response.message);
    }
    var ares = Object.keys(res).map(function(key) {
      var e = res[key];
      e.name = res[key].name + " " + res[key].lastName;
      e.email = res[key].mail;
      e.celular = res[key].celular;
      e.fechaNacimiento = res[key].fechaNacimiento;

      console.log(e.name);
      return e;
    });
    this.setState({ usuarios: ares });
  };

  onChangeProfessional = (professionalId, professionalName) => {
    this.getTurnos(this.state.currentDate, professionalId);
  };

  callTurnosAPI = async (date, professionalId) => {
    const response = await fetch(
      "http://190.105.227.203/turnos/turnos?professionalId=" +
        professionalId +
        "&date=" +
        date
    );
    const res = await response.json();
    //console.log(res);
    if (response.status !== 200) {
      throw Error(response.message);
    }

    var ares = Object.keys(res).map(function(key) {
      var e = res[key];
      e.start = new Date(res[key].start);
      e.end = new Date(res[key].end);
      if (res[key].available === 0) {
        e.hexColor = "lightgrey";
      } else if (res[key].title == null) {
        e.hexColor = "green";
      }
      e.title = res[key].title;
      e.status = "intialised";
      return e;
    });
    //const ares = res.map(e =>{ start:new Date({e.start}), end: new Date({e.end}) }  )};
    this.setState({ events: ares });
    //console.log(ares);
    return res;
  };

  getTurnos = (date, professionalId) => {
    this.callTurnosAPI(date, professionalId)
      .then()
      .catch(err => console.log(err));
  };

  handleSelect = ({ start, end }) => {
    // $("#foo").Modal();
    var name = "";
    var email = "";
    var celular = "";

    this.setState({
      paciente: name,
      email: email,
      celular: celular,
      fechastartevent: start,
      fechaendevent: end,
      fechaNacimiento: new Date("1980-01-02"),
      modaltitle: "Crear Turno",
      show: true,
      deshabilitar: false
    });
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  handleSave = () => {
    console.log("nombre: " + this.state.paciente);
    console.log("email: " + this.state.email);
    let length = this.state.fechastartevent;
    if (length === 0) return;
    length = this.state.fechaendevent;
    if (length === 0) return;
    console.log("deshabilitar " + this.state.deshabilitar);
    if (this.state.deshabilitar === true) {
      this.deshabilitarTurnoAPI();
    } else {
      length = this.state.paciente.length;
      if (length === 0) return;
      length = this.state.email.length;
      if (length === 0) return;
      this.saveTurnoAPI();
    }
    this.setState({ show: false });
  };

  saveTurnoAPI = () => {
    console.log("Token " + this.props.token);
    axios
      .post(
        "http://190.105.227.203/turnos/saveTurnAdmin",
        {
          professionalId: this.props.professionalId,
          nombre: this.state.paciente,
          email: this.state.email,
          celular: this.state.celular,
          fechaNacimiento: this.getDate(new Date(this.state.fechaNacimiento)),
          startdate: this.getDate(new Date(this.state.fechastartevent)),
          enddate: this.getDate(new Date(this.state.fechaendevent))
        },
        {
          headers: { Authorization: "Bearer " + this.props.token }
        }
      )
      .then(response => {
        //   if (response.data.affectedRows == 1) {

        //} else {
        //}
        this.getTurnos(this.state.currentDate, this.props.professionalId);
      })
      .catch(error => {});
  };

  deshabilitarTurnoAPI = () => {
    axios
      .post(
        "http://190.105.227.203/turnos/deshabilitarTurno",
        {
          professionalId: this.props.professionalId,
          startdate: this.getDate(new Date(this.state.fechastartevent)),
          enddate: this.getDate(new Date(this.state.fechaendevent))
        },
        {
          headers: { Authorization: "Bearer " + this.props.token }
        }
      )
      .then(response => {
        //   if (response.data.affectedRows == 1) {

        //} else {
        //}
        this.getTurnos(this.state.currentDate, this.props.professionalId);
      })
      .catch(error => {});
  };

  getDate = date => {
    var tdate =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " " +
      date.getHours() +
      ":" +
      date.getMinutes();
    return tdate;
  };

  onNavigate = (date, view, action) => {
    console.log("#### onNavigate");
    console.log("#### date=", date);
    console.log("#### view=", view);
    var tdate =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    this.setState({ currentDate: tdate });
    this.getTurnos(tdate, this.props.professionalId);
  };

  eventStyleGetter = (event, start, end, isSelected) => {
    //console.log(event);
    var backgroundColor = event.hexColor;
    var style = {
      backgroundColor: backgroundColor,
      border: "1px solid lightgrey"
    };
    return {
      style: style
    };
  };

  showCurrentEvent = event => {
    var name = "";
    var email = "";
    var celular = "";
    var fechaNacimiento = new Date("1980-01-02");
    if (event.title !== null) {
      var fields = event.title.split("|");
      name = fields[0];
      email = fields[1];
      celular = fields[2];
      fechaNacimiento = new Date(fields[3].trim());
      console.log("fechanac " + fechaNacimiento);
      this.setState({
        modaltitle: "Editar Turno"
      });
    } else {
      this.setState({
        modaltitle: "Crear Turno"
      });
    }
    this.setState({
      paciente: name,
      email: email,
      celular: celular,
      fechaNacimiento: fechaNacimiento,
      fechastartevent: event.start,
      fechaendevent: event.end,
      show: true,
      deshabilitar: false
    });
  };

  getPacienteState = () => {
    const length = this.state.paciente.length;
    if (length > 0) return "success";
    else return "error";
  };

  getEmailState = () => {
    const length = this.state.email.length;
    if (length > 0) return "success";
    else return "error";
  };

  getInicioState = () => {
    const length = this.state.fechastartevent;
    if (length > 0) return "success";
    else return "error";
  };

  getFinState = () => {
    const length = this.state.fechaendevent;
    if (length > 0) return "success";
    else return "error";
  };

  onChangeNombre = (event, { newValue }) => {
    this.setState({
      paciente: newValue
    });
  };

  //Sugestions

  // When suggestion is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.
  getSuggestionValue = suggestion => suggestion.name;

  // Use your imagination to render suggestions.
  renderSuggestion = suggestion => <div>{suggestion.name}</div>;

  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : this.state.usuarios.filter(
          user => user.name.toLowerCase().slice(0, inputLength) === inputValue
        );
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    const sugg = this.getSuggestions(value);
    this.setState({
      suggestions: sugg
    });

    if (sugg.length > 0) {
      this.setState({
        email: sugg[0].email,
        celular: sugg[0].celular
      });
      if (sugg[0].fechaNacimiento != null) {
        this.setState({
          fechaNacimiento: new Date(sugg[0].fechaNacimiento)
        });
      }
    }
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  getSuggestionEmail = suggestion => suggestion.name;

  render() {
    const { paciente, suggestions } = this.state;

    const inputProps = {
      placeholder: "Ingrese para buscar usuario",
      value: paciente,
      onChange: this.onChangeNombre
    };

    return (
      <div
        style={{
          marginLeft: "20px",
          marginTop: "0px",
          marginRight: "20px",
          height: "100%"
        }}
      >
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modaltitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <FormGroup
                controlId="Paciente"
                validationState={this.getPacienteState()}
              >
                <ControlLabel>Paciente: </ControlLabel>
                <Autosuggest
                  suggestions={suggestions}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  getSuggestionValue={this.getSuggestionValue}
                  renderSuggestion={this.renderSuggestion}
                  inputProps={inputProps}
                  value={this.state.paciente}
                  onChange={e => this.setState({ paciente: e.target.value })}
                />

                <FormControl.Feedback />
              </FormGroup>
              <FormGroup
                controlId="Email"
                validationState={this.getEmailState()}
              >
                <ControlLabel>E-mail: </ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.email}
                  autoComplete="email0000"
                  onChange={e => this.setState({ email: e.target.value })}
                  placeholder=""
                />
                <FormControl.Feedback />
              </FormGroup>
              <FormGroup controlId="Celular">
                <ControlLabel>Telefono: </ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.celular}
                  onChange={e => this.setState({ celular: e.target.value })}
                  autoComplete="celular0000"
                  placeholder=""
                />
                <FormControl.Feedback />
              </FormGroup>
              <FormGroup controlId="FechaNacimiento">
                <ControlLabel>Fecha de Nacimiento: </ControlLabel>
                <DateTimePicker
                  value={this.state.fechaNacimiento}
                  format={"dd/MM/yyyy"}
                  autoComplete="fechaNac0000"
                  onChange={value => this.setState({ fechaNacimiento: value })}
                />
                <FormControl.Feedback />
              </FormGroup>
              <FormGroup
                controlId="Inicio"
                validationState={this.getInicioState()}
              >
                <ControlLabel>Inicio: </ControlLabel>
                <DateTimePicker
                  value={this.state.fechastartevent}
                  step={20}
                  autoComplete="inicio0000"
                  format={"dd/MM/yyyy hh:mm"}
                  onChange={value => this.setState({ fechastartevent: value })}
                />
                <FormControl.Feedback />
              </FormGroup>
              <FormGroup controlId="Fin" validationState={this.getFinState()}>
                <ControlLabel>Fin: </ControlLabel>
                <DateTimePicker
                  value={this.state.fechaendevent}
                  autoComplete="fin0000"
                  format={"dd/MM/yyyy hh:mm"}
                  //   format={{ raw: "MMM dd, yyyy" }}
                  step={20}
                  onChange={value => this.setState({ fechaendevent: value })}
                />
                <FormControl.Feedback />
              </FormGroup>
              <FormGroup controlId="deshabilitar">
                <Checkbox
                  unchecked="true"
                  onClick={e =>
                    this.setState({ deshabilitar: e.target.checked })
                  }
                  value={this.state.deshabilitar}
                >
                  Deshabilitar turno
                </Checkbox>
              </FormGroup>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleSave} type="submit" bsStyle="primary">
              Guardar Cambios
            </Button>
            <Button onClick={this.handleClose}>Cerrar</Button>
          </Modal.Footer>
        </Modal>

        <BigCalendar
          selectable
          events={this.state.events}
          localizer={localizer}
          defaultDate={new Date()}
          defaultView={BigCalendar.Views.WEEK}
          step={20}
          timeslots={1}
          onSelectEvent={event => this.showCurrentEvent(event)}
          onSelectSlot={this.handleSelect}
          startAccessor="start"
          endAccessor="end"
          views={["day", "week", "agenda"]}
          min={new Date(2017, 10, 0, 9, 0, 0)}
          max={new Date(2030, 10, 0, 19, 0, 0)}
          messages={{
            next: "Siguiente",
            previous: "Atrás",
            today: "Ahora",
            day: "Día",
            week: "Semana"
          }}
          onNavigate={this.onNavigate}
          eventPropGetter={this.eventStyleGetter}
          style={{ height: "100hv", minHeight: "800px" }}
        />
      </div>
    );
  }
}

export default TurnosCalendar;



// WEBPACK FOOTER //
// ./src/components/turnosCalendar.jsx